import { useTranslation } from "react-i18next";
import { EnumSection, enumsectionToI18nKey } from "../../generated/enums";
import { EmptyState } from "../common/EmptyState";
import { Header } from "../Header";
import { sectionToIcon } from "../type/default";

// Page d'attente des entrées de menu dont le contenu n'existe pas encore côté API.
export const ComingSoonPage = ({ section }: { section: EnumSection }) => {
  const { t } = useTranslation();
  return (
    <div className="p-4">
      <Header
        title={t(enumsectionToI18nKey[section])}
        icon={sectionToIcon[section]}
      />
      <EmptyState
        icon="screwdriver-wrench"
        title={t("coming-soon-title")}
        description={t("coming-soon-text")}
      />
    </div>
  );
};
